import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

import Dashboard from "../dashboard/Dashboard";
import Province from "../setting/province/Province";
import City from "../setting/city/City";
import Zone from "../setting/zone/Zone";
import WaitingList from "../../share-users/waiting/WaitingList";
import ConfirmedList from "../../share-users/confirmed/ConfirmedList";
import FailedList from "../../share-users/failed/FailedList";

const AdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* setting */}
        <Route path="/province" element={<Province />} />
        <Route path="/city" element={<City />} />
        <Route path="/zone" element={<Zone />} />
        <Route path="/waiting-list" element={<WaitingList />} />
        <Route path="/confirmed-list" element={<ConfirmedList />} />
        <Route path="/failed-list" element={<FailedList />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default AdminRoutes;
